module.exports = __webpack_public_path__ + "static/img/arrow_right.d69a453b.svg";